import List from './components/List/List';

export default function App() {
  return (
    <>
      <List />
    </>
  );
}